import { units } from '@ui/css';
import { combineTokens, makeScaleableToken } from '@utils/css';

const tokens = combineTokens("--dropzone-with-tile", {
  left: "0%",
  top: "0%",
  width: "0%",
  height: "0%",
  padding: [units.px(10), makeScaleableToken]
});
const dropzone = "_35sdobd451";
const dropzoneTile = "_35sdc75e4g";

export { dropzone, dropzoneTile, tokens };
import "./atom.with-tile.style.linaria.module.css";
//# sourceMappingURL=atom.with-tile.style.js.map
